import { render, staticRenderFns } from "./PressKit.vue?vue&type=template&id=209b33c6&scoped=true"
import script from "./PressKit.vue?vue&type=script&lang=js"
export * from "./PressKit.vue?vue&type=script&lang=js"
import style0 from "./PressKit.vue?vue&type=style&index=0&id=209b33c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b33c6",
  null
  
)

export default component.exports